export const CANADA_ID = 1;
export const US_ID = 2;
export const OTHER_COUNTRY_ID = 0;
export const FIRST_PROVINCE_ID = 1;
export const FIRST_STATE_ID = 13;
export const OTHER_REGION_ID = 66;

export interface Country {
    id: number;
    name: string;
    abbreviation: string;
}

export const CountryOptions = (): Array<Country> => {
    return [
        {
            id: CANADA_ID,
            name: "Canada",
            abbreviation: "CA",
        },
        {
            id: US_ID,
            name: "United States",
            abbreviation: "US",
        },
        {
            id: 3,
            name: "United Kingdom",
            abbreviation: "UK",
        },
        {
            id: 5,
            name: "Afghanistan",
            abbreviation: "AF",
        },
        {
            id: 6,
            name: "Åland Islands",
            abbreviation: "AX",
        },
        {
            id: 7,
            name: "Albania",
            abbreviation: "AL",
        },
        {
            id: 8,
            name: "Algeria",
            abbreviation: "DZ",
        },
        {
            id: 9,
            name: "American Samoa",
            abbreviation: "AS",
        },
        {
            id: 10,
            name: "Andorra",
            abbreviation: "AD",
        },
        {
            id: 11,
            name: "Angola",
            abbreviation: "AO",
        },
        {
            id: 12,
            name: "Anguilla",
            abbreviation: "AI",
        },
        {
            id: 13,
            name: "Antigua & Barbuda",
            abbreviation: "AG",
        },
        {
            id: 14,
            name: "Argentina",
            abbreviation: "AR",
        },
        {
            id: 15,
            name: "Armenia",
            abbreviation: "AM",
        },
        {
            id: 16,
            name: "Aruba",
            abbreviation: "AW",
        },
        {
            id: 17,
            name: "Australia",
            abbreviation: "AU",
        },
        {
            id: 18,
            name: "Austria",
            abbreviation: "AT",
        },
        {
            id: 19,
            name: "Azerbaijan",
            abbreviation: "AZ",
        },
        {
            id: 20,
            name: "Bahamas",
            abbreviation: "BS",
        },
        {
            id: 21,
            name: "Bahrain",
            abbreviation: "BH",
        },
        {
            id: 22,
            name: "Bangladesh",
            abbreviation: "BD",
        },
        {
            id: 23,
            name: "Barbados",
            abbreviation: "BB",
        },
        {
            id: 24,
            name: "Belarus",
            abbreviation: "BY",
        },
        {
            id: 25,
            name: "Belgium",
            abbreviation: "BE",
        },
        {
            id: 26,
            name: "Belize",
            abbreviation: "BZ",
        },
        {
            id: 27,
            name: "Benin",
            abbreviation: "BJ",
        },
        {
            id: 28,
            name: "Bermuda",
            abbreviation: "BM",
        },
        {
            id: 29,
            name: "Bhutan",
            abbreviation: "BT",
        },
        {
            id: 30,
            name: "Bolivia",
            abbreviation: "BO",
        },
        {
            id: 31,
            name: "Bosnia & Herzegovina",
            abbreviation: "BA",
        },
        {
            id: 32,
            name: "Botswana",
            abbreviation: "BW",
        },
        {
            id: 33,
            name: "Brazil",
            abbreviation: "BR",
        },
        {
            id: 34,
            name: "British Indian Ocean Territory",
            abbreviation: "IO",
        },
        {
            id: 35,
            name: "British Virgin Islands",
            abbreviation: "VG",
        },
        {
            id: 36,
            name: "Brunei",
            abbreviation: "BN",
        },
        {
            id: 37,
            name: "Bulgaria",
            abbreviation: "BG",
        },
        {
            id: 38,
            name: "Burkina Faso",
            abbreviation: "BF",
        },
        {
            id: 39,
            name: "Burundi",
            abbreviation: "BI",
        },
        {
            id: 40,
            name: "Cambodia",
            abbreviation: "KH",
        },
        {
            id: 41,
            name: "Cameroon",
            abbreviation: "CM",
        },
        {
            id: 42,
            name: "Canary Islands",
            abbreviation: "IC",
        },
        {
            id: 43,
            name: "Cape Verde",
            abbreviation: "CV",
        },
        {
            id: 44,
            name: "Caribbean Netherlands",
            abbreviation: "BQ",
        },
        {
            id: 45,
            name: "Cayman Islands",
            abbreviation: "KY",
        },
        {
            id: 46,
            name: "Central African Republic",
            abbreviation: "CF",
        },
        {
            id: 47,
            name: "Ceuta & Melilla",
            abbreviation: "EA",
        },
        {
            id: 48,
            name: "Chad",
            abbreviation: "TD",
        },
        {
            id: 49,
            name: "Chile",
            abbreviation: "CL",
        },
        {
            id: 50,
            name: "China",
            abbreviation: "CN",
        },
        {
            id: 51,
            name: "Colombia",
            abbreviation: "CO",
        },
        {
            id: 52,
            name: "Comoros",
            abbreviation: "KM",
        },
        {
            id: 53,
            name: "Republic of the Congo",
            abbreviation: "CG",
        },
        {
            id: 54,
            name: "Democratic Republic of the Congo",
            abbreviation: "CD",
        },
        {
            id: 55,
            name: "Cook Islands",
            abbreviation: "CK",
        },
        {
            id: 56,
            name: "Costa Rica",
            abbreviation: "CR",
        },
        {
            id: 57,
            name: "Côte d’Ivoire",
            abbreviation: "CI",
        },
        {
            id: 58,
            name: "Croatia",
            abbreviation: "HR",
        },
        {
            id: 59,
            name: "Cuba",
            abbreviation: "CU",
        },
        {
            id: 60,
            name: "Curaçao",
            abbreviation: "CW",
        },
        {
            id: 61,
            name: "Cyprus",
            abbreviation: "CY",
        },
        {
            id: 62,
            name: "Czechia",
            abbreviation: "CZ",
        },
        {
            id: 63,
            name: "Denmark",
            abbreviation: "DK",
        },
        {
            id: 64,
            name: "Djibouti",
            abbreviation: "DJ",
        },
        {
            id: 65,
            name: "Dominica",
            abbreviation: "DM",
        },
        {
            id: 66,
            name: "Dominican Republic",
            abbreviation: "DO",
        },
        {
            id: 67,
            name: "Ecuador",
            abbreviation: "EC",
        },
        {
            id: 68,
            name: "Egypt",
            abbreviation: "EG",
        },
        {
            id: 69,
            name: "El Salvador",
            abbreviation: "SV",
        },
        {
            id: 70,
            name: "Equatorial Guinea",
            abbreviation: "GQ",
        },
        {
            id: 71,
            name: "Eritrea",
            abbreviation: "ER",
        },
        {
            id: 72,
            name: "Estonia",
            abbreviation: "EE",
        },
        {
            id: 73,
            name: "Eswatini",
            abbreviation: "SZ",
        },
        {
            id: 74,
            name: "Ethiopia",
            abbreviation: "ET",
        },
        {
            id: 75,
            name: "Falkland Islands",
            abbreviation: "FK",
        },
        {
            id: 76,
            name: "Faroe Islands",
            abbreviation: "FO",
        },
        {
            id: 77,
            name: "Fiji",
            abbreviation: "FJ",
        },
        {
            id: 78,
            name: "Finland",
            abbreviation: "FI",
        },
        {
            id: 79,
            name: "France",
            abbreviation: "FR",
        },
        {
            id: 80,
            name: "French Guiana",
            abbreviation: "GF",
        },
        {
            id: 81,
            name: "French Polynesia",
            abbreviation: "PF",
        },
        {
            id: 82,
            name: "Gabon",
            abbreviation: "GA",
        },
        {
            id: 83,
            name: "Gambia",
            abbreviation: "GM",
        },
        {
            id: 84,
            name: "Georgia",
            abbreviation: "GE",
        },
        {
            id: 85,
            name: "Germany",
            abbreviation: "DE",
        },
        {
            id: 86,
            name: "Ghana",
            abbreviation: "GH",
        },
        {
            id: 87,
            name: "Gibraltar",
            abbreviation: "GI",
        },
        {
            id: 88,
            name: "Greece",
            abbreviation: "GR",
        },
        {
            id: 89,
            name: "Greenland",
            abbreviation: "GL",
        },
        {
            id: 90,
            name: "Grenada",
            abbreviation: "GD",
        },
        {
            id: 91,
            name: "Guadeloupe",
            abbreviation: "GP",
        },
        {
            id: 92,
            name: "Guam",
            abbreviation: "GU",
        },
        {
            id: 93,
            name: "Guatemala",
            abbreviation: "GT",
        },
        {
            id: 94,
            name: "Guernsey",
            abbreviation: "GG",
        },
        {
            id: 95,
            name: "Guinea",
            abbreviation: "GN",
        },
        {
            id: 96,
            name: "Guinea-Bissau",
            abbreviation: "GW",
        },
        {
            id: 97,
            name: "Guyana",
            abbreviation: "GY",
        },
        {
            id: 98,
            name: "Haiti",
            abbreviation: "HT",
        },
        {
            id: 99,
            name: "Honduras",
            abbreviation: "HN",
        },
        {
            id: 100,
            name: "Hong Kong",
            abbreviation: "HK",
        },
        {
            id: 101,
            name: "Hungary",
            abbreviation: "HU",
        },
        {
            id: 102,
            name: "Iceland",
            abbreviation: "IS",
        },
        {
            id: 103,
            name: "India",
            abbreviation: "IN",
        },
        {
            id: 104,
            name: "Indonesia",
            abbreviation: "ID",
        },
        {
            id: 105,
            name: "Iran",
            abbreviation: "IR",
        },
        {
            id: 106,
            name: "Iraq",
            abbreviation: "IQ",
        },
        {
            id: 107,
            name: "Ireland",
            abbreviation: "IE",
        },
        {
            id: 108,
            name: "Isle of Man",
            abbreviation: "IM",
        },
        {
            id: 109,
            name: "Israel",
            abbreviation: "IL",
        },
        {
            id: 110,
            name: "Italy",
            abbreviation: "IT",
        },
        {
            id: 111,
            name: "Jamaica",
            abbreviation: "JM",
        },
        {
            id: 112,
            name: "Japan",
            abbreviation: "JP",
        },
        {
            id: 113,
            name: "Jersey",
            abbreviation: "JE",
        },
        {
            id: 114,
            name: "Jordan",
            abbreviation: "JO",
        },
        {
            id: 115,
            name: "Kazakhstan",
            abbreviation: "KZ",
        },
        {
            id: 116,
            name: "Kenya",
            abbreviation: "KE",
        },
        {
            id: 117,
            name: "Kiribati",
            abbreviation: "KI",
        },
        {
            id: 118,
            name: "Kosovo",
            abbreviation: "XK",
        },
        {
            id: 119,
            name: "Kuwait",
            abbreviation: "KW",
        },
        {
            id: 120,
            name: "Kyrgyzstan",
            abbreviation: "KG",
        },
        {
            id: 121,
            name: "Laos",
            abbreviation: "LA",
        },
        {
            id: 122,
            name: "Latvia",
            abbreviation: "LV",
        },
        {
            id: 123,
            name: "Lebanon",
            abbreviation: "LB",
        },
        {
            id: 124,
            name: "Lesotho",
            abbreviation: "LS",
        },
        {
            id: 125,
            name: "Liberia",
            abbreviation: "LR",
        },
        {
            id: 126,
            name: "Libya",
            abbreviation: "LY",
        },
        {
            id: 127,
            name: "Liechtenstein",
            abbreviation: "LI",
        },
        {
            id: 128,
            name: "Lithuania",
            abbreviation: "LT",
        },
        {
            id: 129,
            name: "Luxembourg",
            abbreviation: "LU",
        },
        {
            id: 130,
            name: "Macao",
            abbreviation: "MO",
        },
        {
            id: 131,
            name: "Madagascar",
            abbreviation: "MG",
        },
        {
            id: 132,
            name: "Malawi",
            abbreviation: "MW",
        },
        {
            id: 133,
            name: "Malaysia",
            abbreviation: "MY",
        },
        {
            id: 134,
            name: "Maldives",
            abbreviation: "MV",
        },
        {
            id: 135,
            name: "Mali",
            abbreviation: "ML",
        },
        {
            id: 136,
            name: "Malta",
            abbreviation: "MT",
        },
        {
            id: 137,
            name: "Marshall Islands",
            abbreviation: "MH",
        },
        {
            id: 138,
            name: "Martinique",
            abbreviation: "MQ",
        },
        {
            id: 139,
            name: "Mauritania",
            abbreviation: "MR",
        },
        {
            id: 140,
            name: "Mauritius",
            abbreviation: "MU",
        },
        {
            id: 141,
            name: "Mayotte",
            abbreviation: "YT",
        },
        {
            id: 142,
            name: "Mexico",
            abbreviation: "MX",
        },
        {
            id: 143,
            name: "Micronesia",
            abbreviation: "FM",
        },
        {
            id: 144,
            name: "Moldova",
            abbreviation: "MD",
        },
        {
            id: 145,
            name: "Monaco",
            abbreviation: "MC",
        },
        {
            id: 146,
            name: "Mongolia",
            abbreviation: "MN",
        },
        {
            id: 147,
            name: "Montenegro",
            abbreviation: "ME",
        },
        {
            id: 148,
            name: "Montserrat",
            abbreviation: "MS",
        },
        {
            id: 149,
            name: "Morocco",
            abbreviation: "MA",
        },
        {
            id: 150,
            name: "Mozambique",
            abbreviation: "MZ",
        },
        {
            id: 151,
            name: "Myanmar",
            abbreviation: "MM",
        },
        {
            id: 152,
            name: "Namibia",
            abbreviation: "NA",
        },
        {
            id: 153,
            name: "Nauru",
            abbreviation: "NR",
        },
        {
            id: 154,
            name: "Nepal",
            abbreviation: "NP",
        },
        {
            id: 155,
            name: "Netherlands",
            abbreviation: "NL",
        },
        {
            id: 156,
            name: "New Caledonia",
            abbreviation: "NC",
        },
        {
            id: 157,
            name: "New Zealand",
            abbreviation: "NZ",
        },
        {
            id: 158,
            name: "Nicaragua",
            abbreviation: "NI",
        },
        {
            id: 159,
            name: "Niger",
            abbreviation: "NE",
        },
        {
            id: 160,
            name: "Nigeria",
            abbreviation: "NG",
        },
        {
            id: 161,
            name: "Niue",
            abbreviation: "NU",
        },
        {
            id: 162,
            name: "Norfolk Island",
            abbreviation: "NF",
        },
        {
            id: 163,
            name: "North Korea",
            abbreviation: "KP",
        },
        {
            id: 164,
            name: "North Macedonia",
            abbreviation: "MK",
        },
        {
            id: 165,
            name: "Northern Mariana Islands",
            abbreviation: "MP",
        },
        {
            id: 166,
            name: "Norway",
            abbreviation: "NO",
        },
        {
            id: 167,
            name: "Oman",
            abbreviation: "OM",
        },
        {
            id: 168,
            name: "Pakistan",
            abbreviation: "PK",
        },
        {
            id: 169,
            name: "Palau",
            abbreviation: "PW",
        },
        {
            id: 170,
            name: "Palestinian Territories",
            abbreviation: "PS",
        },
        {
            id: 171,
            name: "Panama",
            abbreviation: "PA",
        },
        {
            id: 172,
            name: "Papua New Guinea",
            abbreviation: "PG",
        },
        {
            id: 173,
            name: "Paraguay",
            abbreviation: "PY",
        },
        {
            id: 174,
            name: "Peru",
            abbreviation: "PE",
        },
        {
            id: 175,
            name: "Philippines",
            abbreviation: "PH",
        },
        {
            id: 176,
            name: "Poland",
            abbreviation: "PL",
        },
        {
            id: 177,
            name: "Portugal",
            abbreviation: "PT",
        },
        {
            id: 178,
            name: "Puerto Rico",
            abbreviation: "PR",
        },
        {
            id: 179,
            name: "Qatar",
            abbreviation: "QA",
        },
        {
            id: 180,
            name: "Réunion",
            abbreviation: "RE",
        },
        {
            id: 181,
            name: "Romania",
            abbreviation: "RO",
        },
        {
            id: 182,
            name: "Russia",
            abbreviation: "RU",
        },
        {
            id: 183,
            name: "Rwanda",
            abbreviation: "RW",
        },
        {
            id: 184,
            name: "Samoa",
            abbreviation: "WS",
        },
        {
            id: 185,
            name: "San Marino",
            abbreviation: "SM",
        },
        {
            id: 186,
            name: "São Tomé & Príncipe",
            abbreviation: "ST",
        },
        {
            id: 187,
            name: "Saudi Arabia",
            abbreviation: "SA",
        },
        {
            id: 188,
            name: "Senegal",
            abbreviation: "SN",
        },
        {
            id: 189,
            name: "Serbia",
            abbreviation: "RS",
        },
        {
            id: 190,
            name: "Seychelles",
            abbreviation: "SC",
        },
        {
            id: 191,
            name: "Sierra Leone",
            abbreviation: "SL",
        },
        {
            id: 192,
            name: "Singapore",
            abbreviation: "SG",
        },
        {
            id: 193,
            name: "Sint Maarten",
            abbreviation: "SX",
        },
        {
            id: 194,
            name: "Slovakia",
            abbreviation: "SK",
        },
        {
            id: 195,
            name: "Slovenia",
            abbreviation: "SI",
        },
        {
            id: 196,
            name: "Solomon Islands",
            abbreviation: "SB",
        },
        {
            id: 197,
            name: "Somalia",
            abbreviation: "SO",
        },
        {
            id: 198,
            name: "South Africa",
            abbreviation: "ZA",
        },
        {
            id: 199,
            name: "South Korea",
            abbreviation: "KR",
        },
        {
            id: 200,
            name: "South Sudan",
            abbreviation: "SS",
        },
        {
            id: 201,
            name: "Spain",
            abbreviation: "ES",
        },
        {
            id: 202,
            name: "Sri Lanka",
            abbreviation: "LK",
        },
        {
            id: 203,
            name: "St. Barthélemy",
            abbreviation: "BL",
        },
        {
            id: 204,
            name: "St. Helena",
            abbreviation: "SH",
        },
        {
            id: 205,
            name: "St. Kitts & Nevis",
            abbreviation: "KN",
        },
        {
            id: 206,
            name: "St. Lucia",
            abbreviation: "LC",
        },
        {
            id: 207,
            name: "St. Martin",
            abbreviation: "MF",
        },
        {
            id: 208,
            name: "St. Pierre & Miquelon",
            abbreviation: "PM",
        },
        {
            id: 209,
            name: "St. Vincent & Grenadines",
            abbreviation: "VC",
        },
        {
            id: 210,
            name: "Sudan",
            abbreviation: "SD",
        },
        {
            id: 211,
            name: "Suriname",
            abbreviation: "SR",
        },
        {
            id: 212,
            name: "Sweden",
            abbreviation: "SE",
        },
        {
            id: 213,
            name: "Switzerland",
            abbreviation: "CH",
        },
        {
            id: 214,
            name: "Syria",
            abbreviation: "SY",
        },
        {
            id: 215,
            name: "Taiwan",
            abbreviation: "TW",
        },
        {
            id: 216,
            name: "Tajikistan",
            abbreviation: "TJ",
        },
        {
            id: 217,
            name: "Tanzania",
            abbreviation: "TZ",
        },
        {
            id: 218,
            name: "Thailand",
            abbreviation: "TH",
        },
        {
            id: 219,
            name: "Timor-Leste",
            abbreviation: "TL",
        },
        {
            id: 220,
            name: "Togo",
            abbreviation: "TG",
        },
        {
            id: 221,
            name: "Tonga",
            abbreviation: "TO",
        },
        {
            id: 222,
            name: "Trinidad & Tobago",
            abbreviation: "TT",
        },
        {
            id: 223,
            name: "Tunisia",
            abbreviation: "TN",
        },
        {
            id: 224,
            name: "Turkey",
            abbreviation: "TR",
        },
        {
            id: 225,
            name: "Turkmenistan",
            abbreviation: "TM",
        },
        {
            id: 226,
            name: "Turks & Caicos Islands",
            abbreviation: "TC",
        },
        {
            id: 227,
            name: "Tuvalu",
            abbreviation: "TV",
        },
        {
            id: 228,
            name: "U.S. Outlying Islands",
            abbreviation: "UM",
        },
        {
            id: 229,
            name: "Uganda",
            abbreviation: "UG",
        },
        {
            id: 230,
            name: "Ukraine",
            abbreviation: "UA",
        },
        {
            id: 231,
            name: "United Arab Emirates",
            abbreviation: "AE",
        },
        {
            id: 232,
            name: "Uruguay",
            abbreviation: "UY",
        },
        {
            id: 233,
            name: "Uzbekistan",
            abbreviation: "UZ",
        },
        {
            id: 234,
            name: "Vanuatu",
            abbreviation: "VU",
        },
        {
            id: 235,
            name: "Vatican City",
            abbreviation: "VA",
        },
        {
            id: 236,
            name: "Venezuela",
            abbreviation: "VE",
        },
        {
            id: 237,
            name: "Vietnam",
            abbreviation: "VN",
        },
        {
            id: 238,
            name: "Wallis & Futuna",
            abbreviation: "WF",
        },
        {
            id: 239,
            name: "Western Sahara",
            abbreviation: "EH",
        },
        {
            id: 240,
            name: "Yemen",
            abbreviation: "YE",
        },
        {
            id: 241,
            name: "Zambia",
            abbreviation: "ZM",
        },
        {
            id: 242,
            name: "Zimbabwe",
            abbreviation: "ZW",
        },
        {
            id: 4,
            name: "Other",
            abbreviation: "O",
        },
    ];
};

export interface Province {
    id: number;
    name: string;
    abbreviation: string;
}

export const ProvinceOptions = (): Array<Province> => {
    return [
        {
            id: 1,
            name: "Ontario",
            abbreviation: "ON",
        },
        {
            id: 2,
            name: "Alberta",
            abbreviation: "AB",
        },
        {
            id: 3,
            name: "British Columbia",
            abbreviation: "BC",
        },
        {
            id: 4,
            name: "Manitoba",
            abbreviation: "MB",
        },
        {
            id: 5,
            name: "New Brunswick",
            abbreviation: "NB",
        },
        {
            id: 6,
            name: "Newfoundland",
            abbreviation: "NL",
        },
        {
            id: 7,
            name: "Northwest Territories",
            abbreviation: "NT",
        },
        {
            id: 8,
            name: "Nova Scotia",
            abbreviation: "NS",
        },
        {
            id: 9,
            name: "Nunavut",
            abbreviation: "NU",
        },
        {
            id: 10,
            name: "Prince Edward Island",
            abbreviation: "PE",
        },
        {
            id: 11,
            name: "Quebec",
            abbreviation: "QC",
        },
        {
            id: 12,
            name: "Saskatchewan",
            abbreviation: "SK",
        },
        {
            id: 65,
            name: "Yukon",
            abbreviation: "AB",
        },
    ];
};

export const StateOptions = (): Array<Province> => {
    return [
        {
            name: "Alabama",
            abbreviation: "AL",
            id: 13,
        },
        {
            name: "Alaska",
            abbreviation: "AK",
            id: 14,
        },
        {
            name: "Arizona",
            abbreviation: "AZ",
            id: 15,
        },
        {
            name: "Arkansas",
            abbreviation: "AR",
            id: 16,
        },
        {
            name: "California",
            abbreviation: "CA",
            id: 17,
        },
        {
            name: "Colorado",
            abbreviation: "CO",
            id: 18,
        },
        {
            name: "Connecticut",
            abbreviation: "CT",
            id: 19,
        },
        {
            name: "Delaware",
            abbreviation: "DE",
            id: 20,
        },
        {
            name: "District Of Columbia",
            abbreviation: "DC",
            id: 21,
        },
        {
            name: "Florida",
            abbreviation: "FL",
            id: 22,
        },
        {
            name: "Georgia",
            abbreviation: "GA",
            id: 23,
        },
        {
            name: "Hawaii",
            abbreviation: "HI",
            id: 24,
        },
        {
            name: "Idaho",
            abbreviation: "ID",
            id: 25,
        },
        {
            name: "Illinois",
            abbreviation: "IL",
            id: 26,
        },
        {
            name: "Indiana",
            abbreviation: "IN",
            id: 27,
        },
        {
            name: "Iowa",
            abbreviation: "IA",
            id: 28,
        },
        {
            name: "Kansas",
            abbreviation: "KS",
            id: 29,
        },
        {
            name: "Kentucky",
            abbreviation: "KY",
            id: 30,
        },
        {
            name: "Louisiana",
            abbreviation: "LA",
            id: 31,
        },
        {
            name: "Maine",
            abbreviation: "ME",
            id: 32,
        },
        {
            name: "Maryland",
            abbreviation: "MD",
            id: 33,
        },
        {
            name: "Massachusetts",
            abbreviation: "MA",
            id: 34,
        },
        {
            name: "Michigan",
            abbreviation: "MI",
            id: 35,
        },
        {
            name: "Minnesota",
            abbreviation: "MN",
            id: 36,
        },
        {
            name: "Mississippi",
            abbreviation: "MS",
            id: 37,
        },
        {
            name: "Missouri",
            abbreviation: "MO",
            id: 38,
        },
        {
            name: "Montana",
            abbreviation: "MT",
            id: 39,
        },
        {
            name: "Nebraska",
            abbreviation: "NE",
            id: 40,
        },
        {
            name: "Nevada",
            abbreviation: "NV",
            id: 41,
        },
        {
            name: "New Hampshire",
            abbreviation: "NH",
            id: 42,
        },
        {
            name: "New Jersey",
            abbreviation: "NJ",
            id: 43,
        },
        {
            name: "New Mexico",
            abbreviation: "NM",
            id: 44,
        },
        {
            name: "New York",
            abbreviation: "NY",
            id: 45,
        },
        {
            name: "North Carolina",
            abbreviation: "NC",
            id: 46,
        },
        {
            name: "North Dakota",
            abbreviation: "ND",
            id: 47,
        },
        {
            name: "Ohio",
            abbreviation: "OH",
            id: 48,
        },
        {
            name: "Oklahoma",
            abbreviation: "OK",
            id: 49,
        },
        {
            name: "Oregon",
            abbreviation: "OR",
            id: 50,
        },
        {
            name: "Pennsylvania",
            abbreviation: "PA",
            id: 51,
        },
        {
            name: "Rhode Island",
            abbreviation: "RI",
            id: 52,
        },
        {
            name: "South Carolina",
            abbreviation: "SC",
            id: 53,
        },
        {
            name: "South Dakota",
            abbreviation: "SD",
            id: 54,
        },
        {
            name: "Tennessee",
            abbreviation: "TN",
            id: 55,
        },
        {
            name: "Texas",
            abbreviation: "TX",
            id: 56,
        },
        {
            name: "Utah",
            abbreviation: "UT",
            id: 57,
        },
        {
            name: "Vermont",
            abbreviation: "VT",
            id: 58,
        },
        {
            name: "Virgin Islands",
            abbreviation: "VI",
            id: 60,
        },
        {
            name: "Virginia",
            abbreviation: "VA",
            id: 59,
        },
        {
            name: "Washington",
            abbreviation: "WA",
            id: 61,
        },
        {
            name: "West Virginia",
            abbreviation: "WV",
            id: 62,
        },
        {
            name: "Wisconsin",
            abbreviation: "WI",
            id: 63,
        },
        {
            name: "Wyoming",
            abbreviation: "WY",
            id: 64,
        },
    ];
};

export const OtherProvinceOptions = (): Array<Province> => {
    return [
        {
            name: "Other",
            abbreviation: "O",
            id: 66,
        },
    ];
};

export const StateProvinceOptions = () =>
    ProvinceOptions().concat(StateOptions());

export const StateNameForId = (id: number) => {
    const result = StateProvinceOptions().find((s) => s.id === id);
    if (result) {
        return result.name;
    } else {
        return "";
    }
};

export const StateAbbreviationForId = (id: number | null) => {
    if (id === null) {
        return "";
    }
    const result = StateProvinceOptions().find((s) => s.id === id);
    if (result) {
        return result.abbreviation;
    } else {
        return "";
    }
};

export const StateIdForName = (name: string) => {
    const result = StateProvinceOptions().find(
        (s) => s.name.toLowerCase() === name.toLowerCase(),
    );
    if (result) {
        return result.id;
    } else {
        return OTHER_REGION_ID;
    }
};

export const StateIdForAbbreviation = (abbreviation: string) => {
    const result = StateProvinceOptions().find(
        (s) => s.abbreviation.toLowerCase() === abbreviation.toLowerCase(),
    );
    if (result) {
        return result.id;
    } else {
        return OTHER_REGION_ID;
    }
};

export const CountryIdForName = (name: string) => {
    const result = CountryOptions().find(
        (c) => c.name.toLowerCase() === name.toLowerCase(),
    );
    if (result) {
        return result.id;
    } else {
        return OTHER_COUNTRY_ID;
    }
};

export const CountryIdForAbbreviation = (abbreviation: string) => {
    const result = CountryOptions().find(
        (c) => c.abbreviation.toLowerCase() === abbreviation.toLowerCase(),
    );
    if (result) {
        return result.id;
    } else {
        return OTHER_COUNTRY_ID;
    }
};

export const CountryAbbreviationForId = (id: number | null) => {
    if (id === null) {
        return "";
    }
    const result = CountryOptions().find((c) => c.id === id);
    if (result) {
        return result.abbreviation;
    } else {
        return "";
    }
};

export type AutocompleteAddress = {
    address_components: {
        long_name: string;
        short_name: string;
        types: string[];
    }[];
};
